export enum L1MeasurementType {
        NotSpecified = "NotSpecified",
        TPR = "TPR",
        PCGSegDuration = "PCGSegDuration",
    }

export class L1Measurement {
    id: string = '';
    confidence: number | null = null;
    remark: string = '';
    l1MeasurementType: L1MeasurementType = L1MeasurementType.NotSpecified;
    createdDate: Date | null = null;
    data: {[key: string]: number} = {};
    temperature?: number = 0;
    heartRate?: number = 0;
    respiratoryRate?: number = 0;
    spO2?: number = 0;
    label?: any = null;

    constructor(init?:Partial<L1Measurement>) {
        if (!init) {
            return;
        }

        Object.assign(this, init);
        
        if (init.createdDate) {
            this.createdDate = new Date(init.createdDate);
        }
    }
}
